import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";
import { getIntlFormatingForPhraseProject } from "../../i18n/IntlRootMixin";

/**
 * Creates a DropDown to change the visibility of a personal list.
 *
 * This component can be invisible for lists that are per default only visible
 * in store context (showGloballyVisibleChanger)
 *
 * This component can be visbible but the changing of the visibility might be
 * disabled for lists that are globally visible but accessed from another
 * store (isGloballyVisibleChangerActive)
 *
 */

type Props = {
    initialValue: boolean;
    showGloballyVisibleChanger: boolean;
    isGloballyVisibleChangerActive: boolean;
    changeVisibility: (event: React.SyntheticEvent) => void;
};

type State = {
    intlFormatting: any;
};

class AddToListVisibilityChanger extends React.Component<Props, State> {
    state = {
        intlFormatting: getIntlFormatingForPhraseProject("EXPLORE")
    };

    render() {
        if (this.props.showGloballyVisibleChanger) {
            return (
                <div>
                    <ControlLabel>
                        {" "}
                        {this.state.intlFormatting.formatMessage({ id: "PERSONAL_LIST_VISIBILITY_HEADLINE" })}
                    </ControlLabel>
                    <FormControl
                        value={this.props.initialValue === false ? "storeVisible" : "globallyVisible"}
                        disabled={!this.props.isGloballyVisibleChangerActive}
                        onChange={(event: React.FormEvent<FormControl>) => this.props.changeVisibility(event as any)}
                        componentClass="select"
                        placeholder="select">
                        <option value="globallyVisible">
                            {this.state.intlFormatting.formatMessage({ id: "PERSONAL_LIST_GLOBAL_VISIBILITY" })}
                        </option>
                        <option value="storeVisible">
                            {this.state.intlFormatting.formatMessage({ id: "PERSONAL_LIST_RESTRICTED_VISIBILITY" })}
                        </option>
                    </FormControl>
                </div>
            );
        }
        return <div />;
    }
}

export default AddToListVisibilityChanger;
